Ext.define('SA.view.color.ColorButton', {
    alias: 'widget.color-button',
    extend: 'SA.view.MenuButton',

    cls: 'sa-color-button',
    colorTpl: new Ext.XTemplate('<div class="sa-color-button-swatch" style="background-color: #{.};"></div>'),
    htmlEncode: false,

    color: '000000',

    refresh() {
        this.setText(this.colorTpl.apply(this.color));
    },

    setColor(color, {suppressEvent = false} = {}) {
        if (color === this.color) {
            return;
        }

        this.color = color;

        this.refresh();

        if (!suppressEvent) {
            this.fireEvent('change', this, color);
        }
    },

    showMenu() {
        this.onMenuShow();

        SA.view.color.ColorWindow.show({
            color: this.color,
            hide: () => this.onMenuHide(),
            select: color => this.setColor(color)
        }).showBy(this.getEl(), 't-b?');
    }
});
